export default __webpack_public_path__ + "static/media/bthere_system_architecture_v2.dcd534a9.jpg";